'use strict';

/**
 * 1. 页面开启
 * 2. 页面隐藏
 * 3. 桥协议可用
 */

var debug;
var assert;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:invoke:event');
    assert = require('assert');
}

var env = require('./env.js');


var win = window;
var doc = document;

var dispatch = function(eventName) {
    if (process.env.NODE_ENV !== 'production') {
        assert(eventName);
        debug('dispatch event "%s"', eventName);
    }

    var ev = doc.createEvent('Events');
    ev.initEvent(eventName);
    doc.dispatchEvent(ev);
};

var addLifecycleEvent = function() {
    if (process.env.NODE_ENV !== 'production') {
        debug('add lifecycle event');
        assert(win.HBNB);
    }

    dispatch('HBNB:ready');
    env.HBNBReady = true;

    win.HBNB.onPageShow = function() {
        dispatch('HBNB:pageshow');
    };

    win.HBNB.onPageHide = function() {
        dispatch('HBNB:pagehide');
    };
};

var checkHBNB = function() {
    setTimeout(function check() {
        if (win.HBNB) {
            addLifecycleEvent();
        } else {
            setTimeout(check, 500);
        }
    });
};

var initEvent = function() {
    if (process.env.NODE_ENV !== 'production') {
        if (env.platform === 'h5') {
            win.HBNB = {};
            addLifecycleEvent();
        }
    }

    if (!env.isHBNBWebview) {
        if (process.env.NODE_ENV !== 'production') {
            debug('not HBNB webview');
        }
        return;
    }

    if (env.platform === 'ios') {
        if (win.HBNB) {
            // ios 会添加 HBNB 对象，如果有该对象，说明桥协议可用
            addLifecycleEvent();
        } else if (env.HBNBVersion) {
            // 带 HBNB 的版本，在可用时会触发 _HBNBReady 事件，表示桥协议可用了
            doc.addEventListener('_HBNBReady', addLifecycleEvent);
        } else {
            // 旧版本只能定时检查
            checkHBNB();
        }
    } else if (env.platform === 'android') {
        if (env.supportPrompt) {
            // 支持 prompt 的版本，是在页面加载前就可用了
            win.HBNB = {};
            addLifecycleEvent();
        } else if (win.HBNB) {
            // 旧版本使用 HBNB 传递数据，存在 HBNB 时可用
            addLifecycleEvent();
        } else {
            // 就版本只能定时检查
            checkHBNB();
        }
    }
};

module.exports = initEvent;



//////////////////
// WEBPACK FOOTER
// ./~/@hfe/hbnb/invoke/event.js
// module id = 592
// module chunks = 0